import { Tab } from "@headlessui/react";
import { BlockWrapper } from "../Preview";
import React from "react";
import { generateContent, generateCss } from "../../functions/sortableFunctions";
const TabPanel = ({ block, ...props }: any) => {
    return (
        <React.Fragment>
            {
                React.createElement(
                    Tab.Panel,
                    {
                        style: {
                            fontFamily: block?.style?.fontFamily
                        },
                        className: generateCss({
                            props: {
                                ...props,
                                block: block
                            },
                        }),
                        id: block.id,
                        ...block.data,
                        as: block.data?.type ? block.data.type : 'div',
                    },
                    block.children ?
                        block.children.map((value: any, index: any) => {
                            return <BlockWrapper
                                {...props}
                                key={index}
                                block={value}
                            />
                        })
                        :
                        generateContent({
                            props: {
                                ...props,
                                block: block
                            },
                        })
                )
            }
        </React.Fragment>

    )
}
export default TabPanel;